<script lang="ts">
import { type Snippet } from 'svelte'
import { fade } from 'svelte/transition'

import { DRAWER_ANIMATION_DURATION } from '@/modules/drawers'

type Props = {
	children: Snippet
	onClick: () => void
}

let { children, onClick }: Props = $props()

const handleClick = (e: MouseEvent) => {
	e.stopPropagation()
	onClick()
}
</script>

<!-- svelte-ignore a11y_click_events_have_key_events -->
<div
	role="button"
	tabindex="0"
	class="absolute bottom-0 left-0 z-1 overflow-hidden w-full h-full bg-neutral-600/40"
	onclick={handleClick}
	in:fade|global={{ duration: DRAWER_ANIMATION_DURATION }}
	out:fade|global={{ duration: DRAWER_ANIMATION_DURATION }}
>
	{@render children()}
</div>
